<div class="data-quality d-flex flex-column h-100 w-100">
  <dx-tab-panel
      class="data-quality-tabs np-clean-tabs flex-fill"
      [dataSource]="pages"
      [selectedIndex]="0"
      [loop]="false"
      [animationEnabled]="false"
      [swipeEnabled]="false">

    <div *dxTemplate="let page of 'chartTemplate'">
      <div class="data-quality-page d-flex flex-column">
        <div class="data-quality-header">
          <div class="data-quality-header-top">
            <div class="data-quality-label">{{ 'Validierungs-Set' | translate }}</div>
            <div class="data-quality-last-validation">
              <span>{{ 'Letzte Validierung' | translate }}:</span>
              <span class="data-quality-last-validation-value">{{ model?.lastChanged | date:'dd.MM.yyyy H:mm:ss' }}</span>
            </div>
          </div>
          <div class="data-quality-header-controls">
            <dx-select-box
                class="data-quality-method"
                [(value)]="selectedValidationMethod"
                [items]="validationMethods"
                displayExpr="name"
                (onValueChanged)="validationMethodChanged()">
              <dxo-select-box-drop-down-options [width]="400"></dxo-select-box-drop-down-options>
            </dx-select-box>
            <dx-button
                class="data-quality-primary-btn"
                stylingMode="contained"
                type="default"
                text="{{ 'Validieren' | translate }}"
                [disabled]="readOnlyUser('dataQualityCalc')"
                (onClick)="calculateQuality()">
            </dx-button>
          </div>
        </div>

        <div class="data-quality-title-block">
          <div class="data-quality-title">
            {{ 'Qualitätsgrad der Produktdaten' | translate }}
            <span class="data-quality-title-hint">
              ({{ 'in den einzelnen Bereichen' | translate }})
            </span>
          </div>

          <div class="data-quality-subtitle">
            {{ 'Anteil gepflegter Informationen in %' | translate }}
          </div>
        </div>

        <div class="data-quality-chart-area flex-fill">
          <dx-chart
              id="chart"
              class="data-quality-chart"
              [dataSource]="[model]"
              [palette]="['#A52A2A' , '#D26915', '#FFA500', '#008000', '#191970']">

            <dxo-title [visible]="false"></dxo-title>

            <dxo-value-axis [min]="0" [max]="100" [visible]="false">
              <dxo-tick [visible]="false"></dxo-tick>
              <dxo-grid [visible]="false"></dxo-grid>
              <dxo-label [visible]="false"></dxo-label>
            </dxo-value-axis>

            <dxo-argument-axis [visible]="true">
              <dxo-grid [visible]="false"></dxo-grid>
              <dxo-tick [visible]="false"></dxo-tick>
            </dxo-argument-axis>

            <dxo-common-series-settings
              argumentField="catalog"
              type="bar"
              [barPadding]="0.1"
              hoverMode="allArgumentPoints"
              selectionMode="allArgumentPoints">
              <dxo-label
                [visible]="true"
                position="outside"
                [customizeText]="customizeText">
              </dxo-label>
            </dxo-common-series-settings>

            <dxi-series valueField="basicsResult" name="{{ 'Stammdaten' | translate }}"></dxi-series>
            <dxi-series valueField="keywordResult" name="{{ 'Suchbegriffe' | translate }}"></dxi-series>
            <dxi-series valueField="mediaResult" name="{{ 'Medien' | translate }}"></dxi-series>
            <dxi-series valueField="featureSystemResult" name="{{ 'Merkmale' | translate }}"></dxi-series>
            <dxi-series valueField="additionalsResult" name="{{ 'Zusätzliche Informationen' | translate }}"></dxi-series>

              <dxo-legend
                  verticalAlignment="bottom"
                  horizontalAlignment="center"
                  itemTextPosition="right"
                  [margin]="10"
                  orientation="horizontal"
              ></dxo-legend>
            <dxo-export [enabled]="false"></dxo-export>
          </dx-chart>
        </div>

        <div class="data-quality-footer d-flex flex-wrap gap-2">
            <dx-button
                icon="glyphicons icon-glyphicons-basic-588-book-open-text"
                stylingMode="outlined"
                type="default"
                (onClick)="openHelpLink()">
            </dx-button>

          <dx-button
              *ngIf="loginService.isUser"
            stylingMode="outlined"
            type="default"
            text="{{ 'Validierungen editieren' | translate }}"
              (onClick)="openValidationEditor()">
          </dx-button>

          <dx-button
            stylingMode="outlined"
            type="default"
            text="{{ 'Download PDF' | translate }}"
            [disabled]="!isQualityCalculated"
            (onClick)="createReport()">
          </dx-button>

          <dx-button
            stylingMode="outlined"
            type="default"
            icon="glyphicons icon-glyphicons-basic-82-refresh"
            hint="{{ 'Aktualisieren' | translate }}"
            (onClick)="reload()">
          </dx-button>
        </div>
      </div>
    </div>

    <div *dxTemplate="let company of 'groupsTemplate'">
      <div class="data-quality-page d-flex flex-column">
        <dataQualityGroups #groupsChart class="flex-fill" [catalogDataQuality]="model"></dataQualityGroups>
        <div class="data-quality-footer d-flex gap-2">
          <dx-drop-down-button
              stylingMode="outlined"
              type="default"
              text="{{ 'Download' | translate }}"
              [items]="groupsChart.exportFormats"
              displayExpr="text"
              (onItemClick)="groupsChart.downloadChart($event.itemData.format)">
          </dx-drop-down-button>
        </div>
      </div>
    </div>

    <div *dxTemplate="let company of 'statisticTemplate'">
      <div class="data-quality-page d-flex flex-column">
        <dataQualityStatistic class="flex-fill" [catalogDataQuality]="model"></dataQualityStatistic>
      </div>
    </div>
  </dx-tab-panel>
</div>
